/**
 * @ngdoc service
 * @name mx.shell.NavigationProviderService
 * @module mx.shell
 *
 * @description
 * Represents an interface for injection concrete implementation of the Navigation Items loading mechanism.
 */
MxNavigationProviderService.$inject = ['mx.shell.RoutingService', 'mx.shell.NavigationItemsLoaderService'];
export function MxNavigationProviderService(routingService, navigationItemsLoaderService) {
	return {
		load,
	};

	/**
	 * @ngdoc method
	 * @async
	 * @name mx.shell.NavigationProviderService#load
	 *
	 * @description
	 * Loads navigation items. Should be implemented
	 *
	 * @param {boolean} param - force reload
	 * @param {boolean} loadOnly - do not change route to current navigation item after loading
	 * @param {NavigationItem[]} existedNavItems - existed navigation items to merge with new loaded items; used to keep locally changed properties
	 *
	 * @returns {promise} Resolved as an array of {@ref mx.shell.NavigationItem navigation items}. See {@ref mx.shell.NavigationItem navigation item} for details
	 */
	async function load(param, loadOnly, existedNavItems) {
		const forceLoad = param === true;

		const isDeepLinking = location.pathname.includes('/object-details/');

		if (isDeepLinking) {
			return [];
		}
		const navItems = await navigationItemsLoaderService.load(forceLoad, existedNavItems);
		const currentNavItem = findCurrentNavItem(navItems);

		if (!loadOnly && currentNavItem) {
			routingService.go(currentNavItem.item.route, currentNavItem.item.parameters);
		}
		return navItems;
	}

	function getRoutingUrl(path, params) {
		if (!params) {
			return path;
		}

		return path.replace(/:([\w\d]+)\??/g, (str, p1) => (params.hasOwnProperty(p1) ? params[p1] : str));
	}

	function findCurrentNavItem(navItems) {
		if (!Array.isArray(navItems)) {
			return null;
		}

		const url = location.href;

		for (const i in navItems) {
			if (navItems.hasOwnProperty(i)) {
				const item = navItems[i];

				if (item.routingItem && item.routingItem.path) {
					const routingUrl = getRoutingUrl(item.routingItem.path, item.parameters);

					if (url.lastIndexOf(routingUrl) === url.length - routingUrl.length) {
						return {
							appCode: item.application,
							url: routingUrl,
							item,
						};
					}
				}

				if (Array.isArray(item.children)) {
					const currentAsChild = findCurrentNavItem(item.children);

					if (currentAsChild) {
						return {
							appCode: item.application,
							url: currentAsChild.url,
							item: currentAsChild.item,
						};
					}
				}
			}
		}

		return null;
	}
}
